<script lang="ts">
  import { SplideSlide } from '@splidejs/svelte-splide';
  import { Carousel } from '..';
  import { GALLERY_AUTOSCROLL_CAROUSEL_OPTIONS } from '../../components/constants/carousel';

  export let images = [
    'https://www.timeoutdubai.com/cloud/timeoutdubai/2021/09/14/yvA5SpUH-IMG-Worlds-1200x800.jpg',
    'https://media.architecturaldigest.com/photos/57c7003fdc03716f7c8289dd/master/pass/IMG%20Worlds%20of%20Adventure%20-%201.jpg',
    'https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0f/ba/29/5c/img-worlds-of-adventure.jpg?w=1200&h=1200&s=1',
    'https://aws-tiqets-cdn.imgix.net/images/content/f02865ee82a44cf0a87e9f72f7258fa1.jpg?auto=format&fit=crop&ixlib=python-3.2.1&q=70&s=e70b1d80f5538f189ea48bea0c48e079',
    'https://dynamic-media-cdn.tripadvisor.com/media/photo-o/1a/b7/b3/eb/caption.jpg?w=1200&h=-1&s=1',
  ];
  export let heading = 'Completed Projects';
  export let rounded = '';
  export let page = '';
  export let objectFit = 'cover';
</script>

<div>
  <div class="title">
    <span class="text-caps">RECENTLY</span>
    <h2>{heading}</h2>
  </div>

  <!-- todo: this type is not working because the note on '../../components/constants/carousel' -->
  <!-- response: I think we need to look into a new implementation of the carousel here to match what we need on the new marketing blocks -->
  <Carousel options={GALLERY_AUTOSCROLL_CAROUSEL_OPTIONS(page)} autoScroll>
    {#each images as image}
      <SplideSlide>
        <img
          style="border-radius: {rounded}px; object-fit:{objectFit};"
          src={image}
          alt=""
        />
      </SplideSlide>
    {/each}
  </Carousel>
</div>

<style>
  .title {
    text-align: center;
  }
  .text-caps {
    margin-bottom: 10px;
    font-weight: 500;
    letter-spacing: 0.25em;
    text-transform: uppercase;
  }
  h2 {
    align-items: center;
    font-size: 50px;
    line-height: 1em;
    text-align: center;
    letter-spacing: -2px;
  }
  img {
    width: 100%;
    height: 300px;
    cursor: pointer;
    object-fit: cover;
  }
  @media screen and (max-width: 640px) {
    h2 {
      font-size: 35px;
    }
  }
  @media screen and (max-width: 430px) {
    h2 {
      font-size: 30px;
    }
  }
</style>
